import type { IFeatureMap } from '../../features';
import {
  affinity,
  autoSend,
  conversation,
  drip,
  emailList,
  emailListFacebook,
  facebook,
  googleAdsSmart,
  invites,
  landingPage,
  mailrailAutoSend,
  mailrailSingleSend,
  mobileGeoFenceRetargeting,
  mobileGeoFencing,
  omni,
  retargeting,
  search,
  seedSegment,
  singleSend,
  smartSend,
  trackedLink,
} from '../../types/campaigns';

export const EnterpriseFalcon: IFeatureMap = {
  data: {
    includedKnownPeople: Infinity,
    includedAnonymousPeople: Infinity,
    trackedActivities: Infinity,
    emailsSent: Infinity,
    standardAudienceData: true,
    audienceSegmentation: true,
    dataImporter: true,
    customDataFields: 200,
    conversionPixels: Infinity,
    implementationsPageVisible: false,
    zapier: Infinity,
    directIntegrations: 0,
    iMISDirectIntegration: false,
    blackbaudDirectIntegration: false,
  },
  ads: {
    [retargeting]: true,
    [mobileGeoFencing]: 10,
    [mobileGeoFenceRetargeting]: 10,
    [facebook]: true,
    [emailListFacebook]: true,
    [emailList]: 10,
    [search]: true,
    [seedSegment]: true,
    [affinity]: true,
    [googleAdsSmart]: false,
    [omni]: true,
  },
  email: {
    [singleSend]: true,
    [smartSend]: true,
    [autoSend]: true,
    [drip]: false,
    [mailrailSingleSend]: true,
    [mailrailAutoSend]: true,
    domainsAuthenticated: Infinity,
  },
  conversations: {
    [conversation]: true,
  },
  creatives: {
    adBannerCreator: Infinity,
  },
  invites: {
    [invites]: true,
    partnerManager: true,
    partnersPerProject: Infinity,
    partnerMarketingCollateralBuilder: true,
    partnerDashboards: Infinity,
  },
  monetization: {
    sponsoredRetargetingCampaigns: true,
    liveSponsorReports: true,
  },
  other: {
    flights: true,
    forms: false,
    [trackedLink]: true,
    [landingPage]: true,
    dedicatedIPs: Infinity,
    users: Infinity,
    childAccountsWithSwitcher: 0,
    childAccountSharingWithPermissionManagement: 0,
    customUserRolesAndPermissionsManagement: false,
  },
  trainingAndSupport: {
    liveChatSupport: true,
    dedicatedCSM: true,
    accessToHelpDeskFeathrAcademyAndFeathrLiveWebinars: true,
    dedicatedStrategicAdvisorHours: 0,
    livePhoneSupport: false,
    dataIntegrationServicesActiveWithLicense: false,
    proResourcesPageVisible: false,
  },
};
